import { getInfo } from '@/api/user';
import { getToken, setToken, removeToken } from 'assets/js/auth';
import Event from '@/utils/event';

const state = {
  token: getToken() || '',
  userInfo: null,
  roles: []
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERINFO: (state, userInfo) => {
    // 如果都为空, 不循环调用
    if (userInfo || state.userInfo) {
      state.userInfo = userInfo;
      Event.$emit('setPermission');
    }
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  }
};

const actions = {
  SET_LOGOUT({ commit }) {
    removeToken();
    commit('SET_TOKEN', null);
    commit('SET_USERINFO', null);
    localStorage.removeItem('userInfo');
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },
  setToken({ commit }, token) {
    setToken(token);
    commit('SET_TOKEN', token);
  },
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response;
          if (data) {
            localStorage.userInfo = JSON.stringify(data);
            commit('SET_USERINFO', data);
          } else {
            commit('SET_USERINFO', null);
          }
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
const getters = {
  isVenture(state) {
    let isVen = false;
    if (state.userInfo && state.userInfo.buList) {
      let i = state.userInfo.buList.find(i => i.name === 'venture');
      if (i) {
        isVen = true;
      }
    }
    return isVen;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
